module.exports = __webpack_public_path__ + "media/images/img-pb-complete+-1684b380817c7c0e33b3c349c7ddcd7b.png";